import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

export class AnswerVariable {
  id: string;
  type: string;
  name: string;
  defaultValue: string;
}

const answerVariablesResource = createCollectionResource<AnswerVariable>({
  name: 'answerVariables',
  endpoint: 'v1/orgs/:orgId/kb-variables/:kbVariableId',
  observerCreator: emptyObserverCreator,
});

export default answerVariablesResource;
